import confirmDialog from '../lib/confirmDialog.js';
import { useEffect, useRef } from 'react';
import { action } from 'lib/actionHelpers.js';

const getHash = () => {
  return new Promise((resolve, reject) => {
    fetch(window.location.pathname)
      .then((res) => res.text())
      .then((html) => {
        const hash = (String(html).match(/\/static\/js\/main\.(.*?)\./) || [])[1];
        resolve(hash);
      });
  });
};

const AppUpdateHandler = () => {
  const checking = useRef(false);
  useEffect(() => {
    const element = document.getElementById('favicon');
    const hostname = String(window.location.hostname).split('.')[0];
    const icon = {
      dev: 'favicon-dev.svg',
      staging: 'favicon-staging.svg',
      localhost: 'favicon-local.svg',
    }[hostname];
    if (icon && element) {
      element.setAttribute('href', `/${icon}`);
      document.body.classList.add(hostname);
    }
  }, []);

  const checkForUpdates = async () => {
    if (checking.current) {
      return;
    }
    const activeElement = document.activeElement;
    if (activeElement && ['SELECT', 'INPUT', 'TEXTAREA'].includes(activeElement.nodeName)) {
      setTimeout(checkForUpdates, 3000);
      return;
    }
    checking.current = true;
    const isProd = !window.location.origin.includes('localhost') && !window.location.origin.includes('127.0.0.1');
    const currAppHash = (([...document.querySelectorAll('script')].map((n) => n.src).filter((n) => n.includes('/static/js/main'))[0] || '').match(/main\.(.*?)\./) || [])[1];
    const newAppHash = await getHash();
    if (newAppHash && isProd && currAppHash !== newAppHash) {
      const doContinue = await confirmDialog({
        message: 'There is a new version of LeadLoop available. Would you like to update now?',
        confirm: 'Update',
        cancel: 'Skip For Now',
      });
      if (doContinue) {
        action('RESET_TO_INITIAL_STATE');
        window.location.reload();
      }
    }
    checking.current = false;
  };

  useEffect(() => {
    setInterval(checkForUpdates, 1000 * 60 * 10);
    setTimeout(checkForUpdates, 10000);
  });

  return null;
};

export default AppUpdateHandler;
